// core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// campfire
import { OpenModule } from '@campfire-nx/open';
import { MaterialModule } from '@campfire-nx/material';

// pipes
import { AddressPipe } from '@open-portal-app/core/pipes/address.pipe';

// components
import {ComponentsModule} from '../components/components.module';

import { HelpRoutingModule } from './help-routing.module';
import { HelpFlowComponent } from './components/help-flow/help-flow.component';
import { HelpQuestionComponent } from './components/help-question/help-question.component';
import { HelpReferenceListComponent } from './components/help-reference-list/help-reference-list.component';
import { HelpInterstitialComponent } from './components/help-interstitial/help-interstitial.component';
import { HelpContactComponent } from './components/help-contact/help-contact.component';

@NgModule({
    providers: [
      AddressPipe
    ],
    declarations: [
        HelpFlowComponent,
        HelpQuestionComponent,
        HelpReferenceListComponent,
        HelpInterstitialComponent,
        HelpContactComponent
    ],
    imports: [
        CommonModule,
        HelpRoutingModule,
        OpenModule,
        MaterialModule,
        ComponentsModule
    ]
})
export class HelpModule { }
